<form novalidate [formGroup]="securityForm" action="#" *ngIf="securityForm != null"> 
  <div class="form-group row">
    <div class="col-md-4 label-column">
      <label for="SecurityQuestion">Question secrète</label>
    </div>
    <div class="col-md-8">   
        <p-dropdown name="questions" formControlName="SecurityQuestion" [autoWidth]="false" 
                      [style]="{'width':'100%','minWidth':'100%'}" panelStyleClass="form-control"
                      optionLabel="Question" filterBy="Question" required="true"
                      filterPlaceholder="Sélectionner une question" [options]="questions"
                      placeholder="Sélectionner une question..."
                      [ngClass]="{ 'is-invalid':  submitted && f?.SecurityQuestion.errors }">
    
          </p-dropdown>
    </div>
</div>
<div class="form-group row">
  <div class="col-md-4 label-column">
    <label for="Response">
      Réponse
    </label>
  </div>
  <div class="col-md-8"> 
        <input type="text" class="form-control" formControlName="Response" id="Response" maxlength="50" 
        placeholder="Réponse (minimum 6 caractères)" minlength="6" [ngStyle]="{'width':'100%'}" 
        maxlength="50" [ngClass]="{ 'is-invalid':  submitted && f?.Response.errors }"/>
        <span style="color: red; font-size: small;" *ngIf="submitted && f?.Response.errors">minimum 6 caractères</span>
  </div>
</div>  
</form> 
